<template>
  <component :is="cardComponent" />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: ['show'],
  components: {},
  computed: {
    ...mapGetters('loan', [
      'isWooricrowdsOfferRequest',
      'investingWooriCrowd',
      'executedWooriCrowd',
    ]),

    cardComponent() {
      const componentName =
        this.investingWooriCrowd || this.executedWooriCrowd
          ? 'WooriCrowdCardActive.vue'
          : 'WooriCrowdCardInit.vue'
      return () => import(`@/components/main/cards/woori-crowd/${componentName}`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
